import './index.less';
import React, { useState } from 'react';
import LayoutPlus from '@/componentsUI/LayoutPlus/Layout/LayoutPlus';
import TableHeaderOnly2Items from '@/components/tableHeaderOnly2Items/TableHeaderOnly2Items';
import { useTranslationPlus } from '@/Core/i18n/useTranslationPlus';
import { useGlobalCurrentWallet } from '@/store/commonStore';
import Crypto from './crypto/Crypto';
import { useWalletAll } from '@/store/walletStore';
import FlatRecharge from './flat/FlatRecharge';

const Recharge = () => {
  const { t } = useTranslationPlus('Wallet');
  const { data } = useWalletAll();
  const { crypto = [], flat = [] } = data || {};
  /**当前使用的钱包 */
  const [currentWalletGlobal] = useGlobalCurrentWallet();

  const [activeTab, setActiveTab] = useState<string>(getTabIndex());

  function getTabIndex() {
    if (currentWalletGlobal?.currencyCategory === 1) {
      //加密
      if (crypto?.length) {
        return '1'
      } else if (flat?.length) {
        return '2'
      }
    } else if (currentWalletGlobal?.currencyCategory === 2) {
      //法币
      if (flat?.length) {
        return '2'
      } else if (crypto?.length) {
        return '1'
      }
    }
  }
  function isShow() {
    if (crypto?.length && flat?.length) {
      return true;
    }
    return false;
  }

  const prefixCls = 'wallet-recharge';

  return (
    <LayoutPlus
      className={`${prefixCls}`}
      header={
        <TableHeaderOnly2Items
          className={`${prefixCls}-header`}
          text1={isShow() ? t('CryptoCurrency') : undefined}
          text2={isShow() ? t('FlatCurrency') : undefined}
          value={activeTab}
          onChange={setActiveTab}
        />
      }
    >
      {activeTab === '1' && <Crypto />}
      {activeTab === '2' && <FlatRecharge />}
    </LayoutPlus>
  );
};

export default Recharge;
